import SaveIcon from '@mui/icons-material/Save';
import LoadingButton from '@mui/lab/LoadingButton';
import { AlertColor } from '@mui/material/Alert';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import CssBaseline from '@mui/material/CssBaseline';
import FormControl from '@mui/material/FormControl';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import axios from 'axios';
import { createEvent } from "ics";
import moment from "moment";
import * as React from 'react';
import { useSelector } from 'react-redux';
import { store } from '..';
import AxiosRequest from '../components/helpers/AxiosRequest';
import i18n from '../i18n';
import * as ModalStore from '../store/Modal';
import { ApplicationState } from '../store';
import './common/meeting.css';
import Participants from './Participants';
import { useNavigate } from "react-router-dom";

const ScheduleMeeting = (props: any) => {
    const userData = useSelector((state: any) => state.appData);
    const [error, setError] = React.useState(false);
    const appLanguage = useSelector((state: ApplicationState) => state.appData?.app4legalData?.lang);
    const direction = appLanguage == "ar" ? "rtl" : "ltr";
    const emailsData = useSelector((state: ApplicationState) => state.appData?.emails);
    const matterData = useSelector((state: ApplicationState) => state.appData?.matterData);
    const accessToken = useSelector((state: ApplicationState) => state.appData?.zoom_access_token);
    const tokens = useSelector((state: ApplicationState) => state.appData?.tokens);
    const contractData = useSelector((state: ApplicationState) => state.appData?.contractData);
    const [topic, setTopic] = React.useState<string>(matterData?.matterTopic ? matterData?.matterTopic : contractData?.contractTopic ? contractData?.contractTopic : userData.app4legalData.moduleRecordName); /*data?.caseValues?.subject*/
    const [inviteParticipants, setInviteParticipants] = React.useState<Boolean>(false);
    const [datePickerValue, setDatePickerValue] = React.useState(moment().format("YYYY-MM-DD"));
    const [hours, setHours] = React.useState<any>(1);
    const [min, setMin] = React.useState<any>(30);
    const [meetDate, setMeetDate] = React.useState("");
    const [meetTime, setMeetTime] = React.useState("");
    const [duration, setDuration] = React.useState<number>(hours * 60 + min);
    const [defaultDate, setDefaultDate] = React.useState<any>(moment().format("YYYY-MM-DD"));
    const [timeZone, setTimeZone] = React.useState(Intl.DateTimeFormat().resolvedOptions().timeZone);
    const [date, setDate] = React.useState<string>(moment().format("YYYY-MM-DD") + 'T' + new Date().getHours() + ":" + new Date().getMinutes() + ':00');
    const [usersId, setUsersId] = React.useState([]);
    const [createMeetingsLimit, setCreateMeetingLimit] = React.useState(false);
    const [createMeetingsLimitMessage, setCreateMeetingLimitMessage] = React.useState("");
    const [openAlert, setOpenAlert] = React.useState(false);
    const [errorAlert, setErrorAlert] = React.useState(false);
    const navigate = useNavigate();
    const [loading, setLoading] = React.useState(false);
    const timeZones: any = {
        "Pacific/Midway": "(GMT-11:00) Midway Island, Samoa",
        "Pacific/Pago_Pago": "(GMT-11:00) Pago Pago",
        "Pacific/Honolulu": "(GMT-10:00) Hawaii",
        "America/Anchorage": "(GMT-8:00) Alaska",
        "America/Juneau": "(GMT-8:00) Juneau",
        "America/Vancouver": "(GMT-7:00) Vancouver",
        "America/Los_Angeles": "(GMT-7:00) Pacific Time (US and Canada)",
        "America/Tijuana": "(GMT-7:00) Tijuana",
        "America/Phoenix": "(GMT-7:00) Arizona",
        "America/Whitehorse": "(GMT-7:00) Yukon",
        "America/Edmonton": "(GMT-6:00) Edmonton",
        "America/Denver": "(GMT-6:00) Mountain Time (US and Canada)",
        "America/Mazatlan": "(GMT-6:00) Mazatlan",
        "America/Regina": "(GMT-6:00) Saskatchewan",
        "America/Guatemala": "(GMT-6:00) Guatemala",
        "America/El_Salvador": "(GMT-6:00) El Salvador",
        "America/Managua": "(GMT-6:00) Managua",
        "America/Costa_Rica": "(GMT-6:00) Costa Rica",
        "America/Tegucigalpa": "(GMT-6:00) Tegucigalpa",
        "America/Chihuahua": "(GMT-6:00) Chihuahua",
        "America/Winnipeg": "(GMT-5:00) Winnipeg",
        "America/Chicago": "(GMT-5:00) Central Time (US and Canada)",
        "America/Mexico_City": "(GMT-5:00) Mexico City",
        "America/Panama": "(GMT-5:00) Panama",
        "America/Bogota": "(GMT-5:00) Bogota",
        "America/Lima": "(GMT-5:00) Lima",
        "America/Monterrey": "(GMT-5:00) Monterrey",
        "America/Eirunepe": "(GMT-5:00) Acre",
        "America/Montreal": "(GMT-4:00) Montreal",
        "America/New_York": "(GMT-4:00) Eastern Time (US and Canada)",
        "America/Indianapolis": "(GMT-4:00) Indiana (East)",
        "America/Puerto_Rico": "(GMT-4:00) Puerto Rico",
        "America/Caracas": "(GMT-4:00) Caracas",
        "America/Santiago": "(GMT-4:00) Santiago",
        "America/La_Paz": "(GMT-4:00) La Paz",
        "America/Guyana": "(GMT-4:00) Guyana",
        "America/Halifax": "(GMT-3:00) Halifax",
        "America/Montevideo": "(GMT-3:00) Montevideo",
        "America/Araguaina": "(GMT-3:00) Recife",
        "America/Argentina/Buenos_Aires": "(GMT-3:00) Buenos Aires, Georgetown",
        "America/Sao_Paulo": "(GMT-3:00) Sao Paulo",
        "Canada/Atlantic": "(GMT-3:00) Atlantic Time (Canada)",
        "America/St_Johns": "(GMT-2:30) Newfoundland and Labrador",
        "America/Godthab": "(GMT-2:00) Greenland",
        "America/Noronha": "(GMT-2:00) Fernando de Noronha",
        "Atlantic/Cape_Verde": "(GMT-1:00) Cape Verde Islands",
        "Atlantic/Azores": "(GMT+0:00) Azores",
        "UTC": "(GMT+0:00) Universal Time UTC",
        "Etc/Greenwich": "(GMT+0:00) Greenwich Mean Time",
        "Atlantic/Reykjavik": "(GMT+0:00) Reykjavik",
        "Africa/Nouakchott": "(GMT+0:00) Nouakchott",
        "Europe/Dublin": "(GMT+1:00) Dublin",
        "Europe/London": "(GMT+1:00) London",
        "Europe/Lisbon": "(GMT+1:00) Lisbon",
        "Africa/Casablanca": "(GMT+1:00) Casablanca",
        "Africa/Bangui": "(GMT+1:00) West Central Africa",
        "Africa/Algiers": "(GMT+1:00) Algiers",
        "Africa/Tunis": "(GMT+1:00) Tunis",
        "Europe/Belgrade": "(GMT+2:00) Belgrade, Bratislava, Ljubljana",
        "CET": "(GMT+2:00) Sarajevo, Skopje, Zagreb",
        "Europe/Oslo": "(GMT+2:00) Oslo",
        "Europe/Copenhagen": "(GMT+2:00) Copenhagen",
        "Europe/Brussels": "(GMT+2:00) Brussels",
        "Europe/Berlin": "(GMT+2:00) Amsterdam, Berlin, Rome, Stockholm, Vienna",
        "Europe/Amsterdam": "(GMT+2:00) Amsterdam",
        "Europe/Rome": "(GMT+2:00) Rome",
        "Europe/Stockholm": "(GMT+2:00) Stockholm",
        "Europe/Vienna": "(GMT+2:00) Vienna",
        "Europe/Luxembourg": "(GMT+2:00) Luxembourg",
        "Europe/Paris": "(GMT+2:00) Paris",
        "Europe/Zurich": "(GMT+2:00) Zurich",
        "Europe/Madrid": "(GMT+2:00) Madrid",
        "Africa/Harare": "(GMT+2:00) Harare, Pretoria",
        "Europe/Warsaw": "(GMT+2:00) Warsaw",
        "Europe/Prague": "(GMT+2:00) Prague Bratislava",
        "Europe/Budapest": "(GMT+2:00) Budapest",
        "Africa/Tripoli": "(GMT+2:00) Tripoli",
        "Africa/Cairo": "(GMT+2:00) Cairo",
        "Africa/Johannesburg": "(GMT+2:00) Johannesburg",
        "Africa/Khartoum": "(GMT+2:00) Khartoum",
        "Europe/Helsinki": "(GMT+3:00) Helsinki",
        "Africa/Nairobi": "(GMT+3:00) Nairobi",
        "Europe/Sofia": "(GMT+3:00) Sofia",
        "Europe/Istanbul": "(GMT+3:00) Istanbul",
        "Europe/Athens": "(GMT+3:00) Athens",
        "Europe/Bucharest": "(GMT+3:00) Bucharest",
        "Asia/Nicosia": "(GMT+3:00) Nicosia",
        "Asia/Beirut": "(GMT+3:00) Beirut",
        "Asia/Damascus": "(GMT+3:00) Damascus",
        "Asia/Jerusalem": "(GMT+3:00) Jerusalem",
        "Asia/Amman": "(GMT+3:00) Amman",
        "Europe/Moscow": "(GMT+3:00) Moscow",
        "Asia/Baghdad": "(GMT+3:00) Baghdad",
        "Asia/Kuwait": "(GMT+3:00) Kuwait",
        "Asia/Riyadh": "(GMT+3:00) Riyadh",
        "Asia/Bahrain": "(GMT+3:00) Bahrain",
        "Asia/Qatar": "(GMT+3:00) Qatar",
        "Asia/Aden": "(GMT+3:00) Aden",
        "Africa/Djibouti": "(GMT+3:00) Djibouti",
        "Africa/Mogadishu": "(GMT+3:00) Mogadishu",
        "Europe/Kiev": "(GMT+3:00) Kyiv",
        "Europe/Minsk": "(GMT+3:00) Minsk",
        "Europe/Chisinau": "(GMT+3:00) Chisinau",
        "Asia/Dubai": "(GMT+4:00) Dubai",
        "Asia/Muscat": "(GMT+4:00) Muscat",
        "Asia/Baku": "(GMT+4:00) Baku, Tbilisi, Yerevan",
        "Asia/Tehran": "(GMT+4:30) Tehran",
        "Asia/Kabul": "(GMT+4:30) Kabul",
        "Asia/Yekaterinburg": "(GMT+5:00) Yekaterinburg",
        "Asia/Tashkent": "(GMT+5:00) Islamabad, Karachi, Tashkent",
        "Asia/Calcutta": "(GMT+5:30) India",
        "Asia/Kolkata": "(GMT+5:30) Mumbai, Kolkata, New Delhi",
        "Asia/Colombo": "(GMT+5:30) Colombo",
        "Asia/Kathmandu": "(GMT+5:45) Kathmandu",
        "Asia/Almaty": "(GMT+6:00) Almaty",
        "Asia/Dacca": "(GMT+6:00) Dacca",
        "Asia/Dhaka": "(GMT+6:00) Astana, Dhaka",
        "Asia/Rangoon": "(GMT+6:30) Rangoon",
        "Asia/Novosibirsk": "(GMT+7:00) Novosibirsk",
        "Asia/Krasnoyarsk": "(GMT+7:00) Krasnoyarsk",
        "Asia/Bangkok": "(GMT+7:00) Bangkok",
        "Asia/Saigon": "(GMT+7:00) Vietnam",
        "Asia/Jakarta": "(GMT+7:00) Jakarta",
        "Asia/Irkutsk": "(GMT+8:00) Irkutsk, Ulaanbaatar",
        "Asia/Shanghai": "(GMT+8:00) Beijing, Shanghai",
        "Asia/Hong_Kong": "(GMT+8:00) Hong Kong SAR",
        "Asia/Taipei": "(GMT+8:00) Taipei",
        "Asia/Kuala_Lumpur": "(GMT+8:00) Kuala Lumpur",
        "Asia/Singapore": "(GMT+8:00) Singapore",
        "Australia/Perth": "(GMT+8:00) Perth",
        "Asia/Yakutsk": "(GMT+9:00) Yakutsk",
        "Asia/Seoul": "(GMT+9:00) Seoul",
        "Asia/Tokyo": "(GMT+9:00) Osaka, Sapporo, Tokyo",
        "Australia/Darwin": "(GMT+9:30) Darwin",
        "Australia/Adelaide": "(GMT+9:30) Adelaide",
        "Asia/Vladivostok": "(GMT+10:00) Vladivostok",
        "Pacific/Port_Moresby": "(GMT+10:00) Guam, Port Moresby",
        "Australia/Brisbane": "(GMT+10:00) Brisbane",
        "Australia/Sydney": "(GMT+10:00) Canberra, Melbourne, Sydney",
        "Australia/Hobart": "(GMT+10:00) Hobart",
        "Australia/Lord_Howe": "(GMT+10:30) Lord Howe IsIand",
        "Asia/Magadan": "(GMT+11:00) Magadan",
        "SST": "(GMT+11:00) Solomon Islands",
        "Pacific/Noumea": "(GMT+11:00) New Caledonia",
        "Asia/Kamchatka": "(GMT+12:00) Kamchatka",
        "Pacific/Fiji": "(GMT+12:00) Fiji Islands, Marshall Islands",
        "Pacific/Auckland": "(GMT+12:00) Auckland, Wellington",
        "Pacific/Apia": "(GMT+13:00) Independent State of Samoa"
    }
    const current = new Date();
    const [severity, setSeverity] = React.useState<AlertColor | undefined>("success");
    const [open, setOpen] = React.useState(false);
    const [alertContent, setAlertContent] = React.useState("");
    const authCheck = useSelector((state: ApplicationState) => state.appData?.check_zoom_auth);

    const time = current.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false
    });
    const [timePickerValue, setTimePickerValue] = React.useState(time);
    const [endMeetTime, setEndMeetTime] = React.useState(moment(time, 'HH:mm').add(1, 'hours').add(30, 'minutes').format('HH:mm'));
    var today = new Date();
    const handleChange = (event: any) => {
        setHours(event.target.value);
        setDuration(event.target.value * 60 + min);
        setEndMeetTime(moment(timePickerValue, 'HH:mm ').add(parseInt(event.target.value), 'hours').add(min, 'minutes').format('HH:mm'));
    };
    const handleChangeMin = (event: any) => {
        setMin(event.target.value);
        let mins = parseInt(event.target.value)
        setDuration((hours * 60) + mins);
        setEndMeetTime(moment(timePickerValue, 'HH:mm ').add(parseInt(event.target.value), 'minutes').add(hours, 'hours').format('HH:mm'));

    };
    const handleChangeTimezone = (event: SelectChangeEvent) => {
        setTimeZone(event.target.value);
    };
    const getEmails = (email: any, emailsBody: any, users: any) => {
        setUsersId(users);
    };
    const scheduleMeetingEvent = async (e: any) => {
        e.preventDefault();
        try {
            //  setDuration(hours * 60 + min);
            //let newMoment = moment(date).add(parseInt(min), 'minutes').add(parseInt(hours), 'hours');
            let newMoment = moment(date);
            let emailSubject = "Zoom Meeting Invitation";
            await createNewMeeting(newMoment);
        } catch (e) {
            console.log(e);
        }

    };
    const handleClose = () => {
        setOpen(false);
    };
    // const apikeyValue ="a22d9447bfa3181a74eda57a617eff24030b4a8747687132d537bf123fb29dd9"
    const createNewMeeting = async (newMoment: any) => {

        var dataToPost;
        dataToPost = {
            "topic": topic,
            "agenda": topic,
            "title": topic,
            //"default_password": false,
            "duration": duration,
            //"password": "123",
            "pre_schedule": false,
            "timezone": timeZone,
            "start_time": date,
            "schedule_for": userData?.userData?.email,
            "settings": {
                "host_video": false,
                "mute_upon_entry": false,
                "participant_video": false,
                //"meeting_invitees": [{
                //    "email": "debtoolsd@gmail.com"
                //}
                //],
                //"authentication_exception": [
                //    {
                //        "email": "debtoolsd@gmail.com"
                //    }
                //],
                "registrants_confirmation_email": "true"
            }
        }

        let apiKey = userData.app4legalData["x-api-key"];
        let requestOptions = {
            header: {
                "x-api-key": apiKey,
                "Content-type": "application/json; charset=utf-8",
                "x-api-channel": "mobile"
            }
        };
        if (topic && usersId.length > 0) {
            setLoading(true);
            let formDataa = new FormData();
            formDataa.append("meeting_from", "meeting");
            formDataa.append("title", topic);
            formDataa.append("start_date", meetDate ? meetDate : defaultDate);
            formDataa.append("start_time", meetTime ? meetTime : time);
            formDataa.append("end_date", meetDate ? meetDate : defaultDate);
            formDataa.append("end_time", endMeetTime);
            formDataa.append("notify_attendees", "0");

            usersId.map((users, i) => {
                formDataa.append("attendees[" + i + "]", users == 0 ? "1" : users);
                formDataa.append("mandatory[" + i + "]", "1");

            })
            const response = await AxiosRequest.post("api/zoom/create/meeting", dataToPost,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': tokens /*accessToken*/
                    }
                }
            );
            if (response.data.code === 429) {
                setCreateMeetingLimit(true);
                navigate("error");
                setCreateMeetingLimitMessage(response.data.message);
                store.dispatch(ModalStore.actionCreators.openModalError(i18n.t('app.limitAlertMessage')));
                return;
            }
            setInviteParticipants(true);
            formDataa.append("description", "Zoom meeting invitation <br /><a href=\"" + response.data.join_url + "\"> " + response.data.join_url + "</a>");
            let responseAddMeeting = await axios.post(userData.app4legalData["api-base-url"] + "modules/api/calendars/add", formDataa, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    "x-api-key": apiKey,
                    "x-api-channel": "mobile"
                }
            }
            );
            if (responseAddMeeting.data.error == "") {
                setError(false);
                props.handleScheduleClosee("success", i18n.t('app.theMeetingSchedulehasbeensetSuccessfully'));
                store.dispatch(ModalStore.actionCreators.openModalSuccess(i18n.t('app.theMeetingSchedulehasbeensetSuccessfully')))

            }
            else {
                setError(true);
                props.handleScheduleClosee("error", JSON.stringify(responseAddMeeting.data.error));
                //  store.dispatch(ModalStore.actionCreators.openModalError(JSON.stringify(responseAddMeeting.data.error)));
                setLoading(false);
            };

            let data = "";
            for (var i = 0; i < usersId.length; i++) {
                for (var j = 0; j < props.inviteesList.length; j++) {
                    if (props.inviteesList[j].id == usersId[i])
                        data = data + props.inviteesList[j].email + ",";
                }
            }
            let emailss: any[] = [];
            props.inviteesList.map((item: any) => {
                usersId.map((user) => {
                    if (item.id == user)
                        emailss.push(item.email)
                })
            });
            emailss.map(email => {
            });

            let inviteYear = newMoment.year();
            let inviteMonth = newMoment.month() + 1;
            let inviteDay = newMoment.date();
            let inviteHours = newMoment.hour();
            let inviteMinutes = newMoment.minute();
            var test: any = {
                start: [inviteYear, inviteMonth, inviteDay, inviteHours, inviteMinutes],
                duration: { hours: parseInt(hours), minutes: parseInt(min) },
                title: topic,
                description: "Invitation to Zoom Meeting",
                status: "CONFIRMED",
                busyStatus: "BUSY",
                organizer: { name: userData?.app4legalData?.profileName, email: userData?.app4legalData?.email },
            }
            let formData = new FormData();
            createEvent(test, (error, value) => {
                const blob: any = new Blob([value], { type: "text/plain;charset=utf-8" });
                let file = new File([blob], "invite.ics", { type: "text/json;charset=utf-8" });
                formData.append("attachments[0]", file);
                //FileSaver.saveAs(blob, "event-schedule.ics");
            });
            emailss.map((email, index) => {
                formData.append("to[" + index + "]", email);
            });
            formData.append("cc[]", "");
            formData.append("subject", i18n.t('app.invite') + " " + i18n.t('app.title'));
            formData.append("body", "<h5>" + i18n.t('app.youHaveBeenInvitedToJoin') + "</h4><div style=\"background-color:#A3EBB1;padding:10px;width:50%;\">" + topic + " on " + moment(datePickerValue).format("MMM DD, YY") + "  " + timeZone.split("/")[0] + "<br/></div><br/>" + i18n.t('app.useThisLinkToJoinTheMeeting') + "<br/> <a href=\"" + response.data.join_url + "\">" + response.data.join_url + "</a></h5>");
            if (emailss.length > 0) {
                let sendEmailsResponse = await axios.post(userData.app4legalData["api-base-url"] + "modules/api/custom_email/send_notification", formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        "x-api-key": userData.app4legalData["x-api-key"],
                        "x-api-channel": "mobile"
                    }
                });
                if (sendEmailsResponse.data.error == "") {
                    setError(false);
                    setLoading(false);
                    props.handleScheduleClosee("success", i18n.t('app.theMeetingSchedulehasbeensetSuccessfully'));
                    store.dispatch(ModalStore.actionCreators.openModalSuccess(i18n.t('app.theMeetingSchedulehasbeensetSuccessfully')))
                }
                else {
                    setError(true);
                    setLoading(false);
                    props.handleScheduleClosee("error", JSON.stringify(sendEmailsResponse.data.error));
                    //  store.dispatch(ModalStore.actionCreators.openModalError(JSON.stringify(sendEmailsResponse.data.error)));
                };
            };
        }
        if (!topic) {
            props.handleScheduleClosee("error", "Please fill all required data");
            // store.dispatch(ModalStore.actionCreators.openModalError("Please fill all required data"));
            setLoading(false);
        }
        if (usersId.length == 0) {
            props.handleScheduleClosee("error", "Please select at least one user");
            // store.dispatch(ModalStore.actionCreators.openModalError("Please fill all required data"));
            setLoading(false);
        }
    };
    return (<React.Fragment >
        {createMeetingsLimit ? <></> :
            <div dir={direction}>
                {/*<Modal/>*/}
                <AppBar position="static">
                    <Toolbar>
                        <Typography
                            variant="h5"
                            noWrap
                            component="div"
                        >
                            {i18n.t('app.scheduleMeeting')}
                        </Typography>
                    </Toolbar>
                </AppBar>
                <CssBaseline />
                <Paper square sx={{ pb: '50px' }}>
                    <Container maxWidth="sm" sx={{ m: 2 }}>
                        <Grid container sx={{ mb: 1 }} spacing={0}>
                            <Grid item xs={12} md={12}>
                                <Typography variant="subtitle1" display="block" gutterBottom>
                                    {i18n.t('app.meetingTitle')}<b style={{ color: 'red' }}>*</b>
                                </Typography>
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <TextField
                                    id="start"
                                    fullWidth
                                    value={topic}
                                    onChange={(event) => { setTopic(event.target.value) }}
                                    size="small"
                                    variant="outlined"
                                    required
                                />
                            </Grid>
                        </Grid>

                        <Grid container sx={{ mb: 1 }} spacing={1}>
                            <Grid item xs={8} md={8}>


                                <Typography variant="subtitle2" display="block" sx={{ marginBottom: "-12px" }} gutterBottom>
                                    {i18n.t('app.date')}:
                                </Typography>
                                <Grid item xs={12} md={12}>
                                    <TextField
                                        type="date"
                                        onChange={(e) => { setDatePickerValue(e.target.value); setDate(e.target.value + 'T' + timePickerValue + ':00'); setMeetDate(e.target.value); }}
                                        fullWidth
                                        margin="normal"
                                        variant="outlined"
                                        defaultValue={defaultDate}
                                        size="small"
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                </Grid>
                            </Grid>
                            <Grid item xs={4} md={4}>
                                <Typography variant="subtitle2" display="block" sx={{ marginBottom: "-12px" }} gutterBottom>
                                    {i18n.t('app.time')}:
                                </Typography>
                                <Grid item xs={12} md={12}>
                                    <TextField
                                        type="time"
                                        onChange={(e) => {
                                            setTimePickerValue(e.target.value); setDate(datePickerValue + 'T' + e.target.value + ':00'); setMeetTime(e.target.value);
                                            setEndMeetTime(moment(e.target.value, 'HH:mm A').add(hours, 'hours').add(min, 'minutes').format('HH:mm'));
                                        }}
                                        fullWidth
                                        defaultValue={time}
                                        margin="normal"
                                        variant="outlined"
                                        size="small"
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid container sx={{ mb: 1 }} spacing={1}>
                            <Grid item xs={4} md={4}>
                                <Stack
                                    direction={{ xs: 'column', sm: 'column' }}
                                    spacing={{ xs: 0, sm: 0, md: 0 }}
                                >
                                    <Stack>
                                        <Typography variant="subtitle2" display="block" gutterBottom>
                                            {i18n.t('app.duration')}:
                                        </Typography>
                                    </Stack>
                                    <Stack>
                                        <FormControl size="small" >
                                            <Select
                                                native id="grouped-native-select"
                                                value={hours}
                                                onChange={handleChange}
                                                displayEmpty
                                                inputProps={{ 'aria-label': 'Without label' }}
                                            >
                                                <option value={0}>0 hour</option>
                                                <option value={1}>1 hour</option>
                                                <option value={2}>2 hours</option>
                                                <option value={3}>3 hours</option>
                                                <option value={4}>4 hours</option>
                                                <option value={5}>5 hours</option>
                                                <option value={6}>6 hours</option>
                                                <option value={7}>7 hours</option>
                                                <option value={8}>8 hours</option>
                                                <option value={9}>9 hours</option>
                                                <option value={10}>10 hours</option>
                                                <option value={11}>11 hours</option>
                                                <option value={12}>12 hours</option>
                                                <option value={13}>13 hours</option>
                                                <option value={14}>14 hours</option>
                                                <option value={15}>15 hours</option>
                                                <option value={16}>16 hours</option>
                                                <option value={17}>17 hours</option>
                                                <option value={18}>18 hours</option>
                                                <option value={19}>19 hours</option>
                                                <option value={20}>20 hours</option>
                                                <option value={21}>21 hours</option>
                                                <option value={22}>22 hours</option>
                                                <option value={23}>23 hours</option>
                                                <option value={24}>24 hours</option>
                                            </Select>
                                        </FormControl>
                                    </Stack>
                                </Stack>
                            </Grid>

                            <Grid item xs={8} md={4}>
                                <Stack
                                    direction={{ xs: 'column', sm: 'column' }}
                                    spacing={{ xs: 0, sm: 0, md: 0 }}
                                >
                                    <Stack>
                                        <Typography variant="subtitle2" display="block" gutterBottom>
                                            .
                                        </Typography>
                                    </Stack>
                                    <Stack>
                                        <FormControl size="small" >
                                            <Select
                                                native id="grouped-native-select"
                                                value={min}
                                                onChange={handleChangeMin}
                                                displayEmpty
                                                inputProps={{ 'aria-label': 'Without label' }}
                                            >
                                                <option value={0}>0 minutes</option>
                                                <option value={15}>15 minutes</option>
                                                <option value={30}>30 minutes</option>
                                                <option value={45}>45 minutes</option>
                                            </Select>
                                        </FormControl>
                                    </Stack>
                                </Stack>
                            </Grid>
                            <Grid item xs={4} md={4}>
                                <Stack
                                    direction={{ xs: 'column', sm: 'column' }}
                                    spacing={{ xs: 0, sm: 0, md: 0 }}
                                >
                                    <Stack>
                                        <Typography variant="subtitle2" display="block" gutterBottom>
                                            {i18n.t('app.timeZone')}:
                                        </Typography>
                                    </Stack>
                                    <Stack>

                                        <FormControl size="small" >
                                            <Select
                                                native id="grouped-native-select"
                                                value={timeZone}
                                                onChange={handleChangeTimezone}
                                                displayEmpty
                                                inputProps={{ 'aria-label': 'Without label' }}
                                            >
                                                {Object.entries(timeZones).map(([key, value]: any) => <option value={key}>{value}</option>)}

                                            </Select>
                                        </FormControl>
                                    </Stack>
                                </Stack>
                            </Grid>
                        </Grid>
                        <Grid container sx={{ mb: 1, height: "calc(100% - 36px)" }} spacing={1}>
                            <Grid item xs={12} md={12}>
                                <Stack
                                    direction={{ xs: 'column', sm: 'column' }}
                                    spacing={{ xs: 0, sm: 0, md: 0 }}
                                >
                                    <Stack>
                                        <Typography variant="subtitle2" display="block" gutterBottom>
                                            {i18n.t('app.attendees')}
                                        </Typography>
                                    </Stack>
                                    {/*<Box sx={{ maxHeight: '100vh', overflow: 'auto',border:1 }}>*/}
                                    <Stack>
                                        <Grid container className="flex-section">
                                            <Grid
                                                item
                                                xs={12}
                                                className={"flex-col-scroll"}
                                            >
                                                <Participants inviteParticipants={inviteParticipants} inviteesList={props.inviteesList} view={true} getEmails={getEmails} />
                                            </Grid>
                                        </Grid>
                                    </Stack>
                                    {/* </Box>*/}
                                </Stack>
                            </Grid>
                        </Grid>

                    </Container>
                </Paper>
                <AppBar position="sticky" color="default" sx={{ top: 'auto', bottom: 0 }}>
                    <Toolbar sx={{ marginLeft: "auto" }}>
                        <Box sx={{ maxWidth: '70%' }}>
                        </Box>
                        <LoadingButton
                            loading={loading}
                            loadingPosition="start"
                            startIcon={<SaveIcon />}
                            variant="contained"
                            onClick={scheduleMeetingEvent}
                            sx={{ Width: "100%" }}
                            color="primary"
                        >
                            {i18n.t('app.save')}
                        </LoadingButton>
                    </Toolbar>
                </AppBar>
            </div>}
    </React.Fragment>);
};

export default ScheduleMeeting;